import { useState, useRef, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import {
    Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip,
    Grid2 as Grid,
    Tooltip,
} from '@mui/material';
import { AccountCircle, Add, Assignment, Cancel, Check, CleanHands, ClearAll, CloudDone, Delete, DocumentScanner, Download, Edit, Info, Lock, Message, PlayArrow, QrCode, ScreenShare } from '@mui/icons-material';
import { myTimestampToDate, propComparator, propComparatorDate } from "../utils/ui_utils";

import { format } from "date-fns";
import { EventDialog } from "../modals/EventDialog";
import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { delete_Event, get_Event_list } from "../FirebaseUtils/dbEvent";
import { globalstyles } from "../lib/definitions";
import { EventDocumentsDialog } from "../modals/EventDocumentDialog";
import { useAuth } from "../core/AuthProvider";




export default function EventsPage() {
    const dialogRef = useRef()
    const dialogDocRef = useRef()
    const {user} = useAuth()

    const childRefDelete = useRef()
    const [element_list, setElementList] = useState([])
    const [showArchived, setShowArchived] = useState(false)

    const handleNew = () => {
        dialogRef.current.onNew()
    }

    const handleEdit = (r, i) => {
        dialogRef.current.onEdit(r, i)
    }

    const handleCurrent = (r, i) => {
    }
    const handleDoc = (r) => {
        dialogDocRef.current.onOpen(r)
    }
    const handleDelete = (r, i) => {
        const cb = () => {
            console.log(r)
            delete_Event(r.id)
            reloadFn()
        }
        childRefDelete.current.confirmDelete('Cancella Evento', `Sei sicuro di voler cancellare l'evento: <br/><b>${r.event_name}</b><br/> [${r.id_protocol}]`, cb)
    }


    const reloadFn = async () => {
        const data = await get_Event_list()
        setElementList(data.sort(propComparatorDate('event_start')))
    }




    useEffect(() => {
        reloadFn()

    }, [])


    const isVisible = useCallback((s) => {
        if (s.is_debug && user.uid !== "RMjMZx8WtpTskSPP55yVobdXl293"){
            return false
        }
        if ((showArchived && s.is_archived) || (!showArchived && !s.is_archived)){
            return true
        }
    },[showArchived])


    return (
        <Box sx={{ textAlign: 'center', p: 1 }}>

            <DeleteconfirmationSection ref={childRefDelete} />
            <EventDialog ref={dialogRef} reloadFn={reloadFn} />
            <EventDocumentsDialog ref={dialogDocRef} />
            <Card sx={{ border: '1px solid lightblue', mt: 1 }}>
                <CardContent>
                    <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                        <Grid size={"grow"} sx={{ fontSize: '1.2em', fontWeight: 'bold', textAlign: 'left' }}>
                            Lista eventi
                        </Grid>
                        <Grid size={"auto"}>
                            <ButtonGroup size="small">
                                <Button color="secondary" variant={!showArchived ? 'contained' : 'outlined'} onClick={() => setShowArchived(false)}>in corso</Button>
                                <Button color="secondary" variant={showArchived ? 'contained' : 'outlined'} onClick={() => setShowArchived(true)}>archiviati</Button>
                            </ButtonGroup>
                        </Grid>
                        <Grid size={"auto"}>
                            <Button onClick={handleNew} variant="contained" size="small" startIcon={<Add />}>nuovo evento</Button>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ backgroundColor: 'lightgrey' }}>
                        <Grid size="grow">
                            nome
                        </Grid>
                        <Grid size="grow">
                            inizio - fine
                        </Grid>
                        <Grid size="grow">
                            luogo
                        </Grid>
                        <Grid size="grow">
                            giudice
                        </Grid>
                        <Grid size="grow">
                            id protocollo
                        </Grid>
                        <Grid size={3} sx={{ textAlign: 'right' }}>
                        </Grid>

                    </Grid>

                    <Grid >
                        {element_list.filter(s => isVisible(s)).map((s, k) => (
                            <OneEvent
                                key={k}
                                cur_event={s}
                                index={k}
                                handleEdit={handleEdit}
                                handleCurrent={handleCurrent}
                                handleDelete={handleDelete}
                                handleDoc={handleDoc}
                            />
                        ))}
                    </Grid>
                </CardContent>
            </Card>
        </Box >
    );
}


const OneEvent = ({ cur_event, index, handleDelete, handleEdit, handleDoc, is_current }) => {

    return (
        <Grid container sx={globalstyles.list_row} spacing={1} >
            <Grid size={{ sx: 3, md: "grow" }} sx={{ fontWeight: 'bold', color: cur_event.is_archived ? 'red' : '' }}>
                {cur_event.event_name}
            </Grid>
            <Grid size={{ sx: 3, md: "auto" }}>
                {format(myTimestampToDate(cur_event.event_start), 'dd/MM/yyyy')} -&nbsp;
                {format(myTimestampToDate(cur_event.event_end), 'dd/MM/yyyy')}
            </Grid>
            <Grid size={"grow"}>
                {cur_event.location?.name}
            </Grid>
            <Grid size={"grow"}>
                {cur_event.judge?.firstname} {cur_event.judge?.lastname}
            </Grid>
            <Grid size={"grow"}>
                {cur_event.id_protocol}

                {cur_event.lock_catalog &&
                    <Tooltip title="catalogo bloccato">
                        <Lock />
                    </Tooltip>
                }
            </Grid>
            <Grid size={3} sx={{ textAlign: 'right', justifyContent:'space-between' }} container>
                <Tooltip title="gestisci evento">
                    <span>
                        <Button size="small" href={`${cur_event.id}/category`} startIcon={<Assignment />}>gestione</Button>
                    </span>
                </Tooltip>
                <ButtonGroup size="small">
                    <Tooltip title="Proietta risultati">
                        <span>
                            <Button target="_blank" href={`${cur_event.id}/screen`} startIcon={<ScreenShare />}></Button>
                        </span>
                    </Tooltip>
                    <Tooltip title="qrcode evento">
                        <span>
                            <Button color="primary" onClick={() => handleDoc(cur_event, index)} startIcon={<DocumentScanner />}></Button>
                        </span>
                    </Tooltip>
                    {cur_event.is_public &&
                        <Tooltip title="visualizza pagina pubblica">
                            <span>
                                <Button color="secondary" target="_blank" href={`${cur_event.id}/publiccatalog`} startIcon={<CloudDone />}></Button>
                            </span>
                        </Tooltip>
                    }
                    <Tooltip title="modifica">
                        <span>
                            <Button color="warning" onClick={() => handleEdit(cur_event, index)} startIcon={<Edit color="warning" />}></Button>
                        </span>
                    </Tooltip>
                    <Tooltip title="cancella">
                        <span>
                            <Button color="error" disabled={!cur_event.is_archived} onClick={() => handleDelete(cur_event, index)} startIcon={<Delete />}></Button>
                        </span>
                    </Tooltip>
                </ButtonGroup>

            </Grid>
        </Grid>

    )
}




